var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "AuthCard",
    {
      staticClass: "font-raleway",
      attrs: { title: "Forgot Password Confirm" },
    },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid, dirty, handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.submit)
                      },
                    },
                  },
                  [
                    _c("ValidationProvider", {
                      attrs: { name: "username", rules: "c_email|required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "username",
                                    title: "Email address",
                                    name: "username",
                                    type: "email",
                                    placeholder: "Enter your email *",
                                    errors: touched ? errors : [],
                                  },
                                  model: {
                                    value: _vm.username,
                                    callback: function ($$v) {
                                      _vm.username =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "username",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      staticClass: "mt-6",
                      attrs: { name: "code", rules: "code|required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "code",
                                    title: "Verification Code",
                                    name: "code",
                                    type: "password",
                                    placeholder:
                                      "Enter the verification code *",
                                    errors: touched ? errors : [],
                                    disabled: "true",
                                  },
                                  model: {
                                    value: _vm.code,
                                    callback: function ($$v) {
                                      _vm.code = $$v
                                    },
                                    expression: "code",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      staticClass: "mt-6",
                      attrs: {
                        name: "new-password",
                        rules: "password_len|required",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "new-password",
                                    title: "Password",
                                    name: "new-password",
                                    type: "password",
                                    placeholder: "Enter your password *",
                                    errors: touched ? errors : [],
                                  },
                                  model: {
                                    value: _vm.password,
                                    callback: function ($$v) {
                                      _vm.password = $$v
                                    },
                                    expression: "password",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      staticClass: "mt-6",
                      attrs: {
                        name: "confirm",
                        rules: "password:@new-password|required",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "confirm",
                                    title: "Confirm Password",
                                    name: "confirm",
                                    type: "password",
                                    placeholder: "Confirm your password *",
                                    errors: touched ? errors : [],
                                  },
                                  model: {
                                    value: _vm.confirmPassword,
                                    callback: function ($$v) {
                                      _vm.confirmPassword = $$v
                                    },
                                    expression: "confirmPassword",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("UiButton", {
                      staticClass: "my-6 block w-full",
                      attrs: {
                        buttonText: "Submit",
                        type: "submit",
                        disabled: invalid || !dirty,
                        processing: _vm.loading,
                        fullWidth: "",
                      },
                    }),
                    _c("AuthFormLink", {
                      staticClass: "mt-6 flex items-center justify-between",
                      attrs: { text: "Resend Code" },
                      on: { click: _vm.resend },
                    }),
                    _c("AuthFormLink", {
                      staticClass: "mt-2",
                      attrs: { link: "/signin", text: "Return to Sign In" },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }